<template>
<div class="TableBox">
    <search-template page_name="负利润表" :timeMonth='timeMonth' source="total" @search_event='search_event'></search-template>
    <div class="screenBox screenBox1 clear" style="padding-left:0;margin-top:5px">
        <div class="batchDelete" style="float:left" @click="batchEdit">批量编辑</div>
        <div class="batchDelete" style="float:left;background:#FF9B3B;border-color:#FF9B3B;" @click="clearSelection">清空选中</div>
        <div class="batchDelete" style="float:right;margin-left:10px;" @click="init({page:1,exportFlag:true})">导出</div>
        <div class="refreshIcon batchDelete" style="float:right;margin-rigth:0" @click="init({page:1})">
            刷新
            <i class="el-icon-refresh"></i>
        </div>
    </div>
     <ux-grid
        class="uxGridBox"
        ref="plxTable"
        :height="height"
        :checkboxConfig="{checkMethod: selectable, highlight: true}"
        @selection-change="selectionChange"
        @table-body-scroll="scroll"
        show-footer-overflow="tooltip"
        show-overflow="tooltip"
        size="mini">
         <ux-table-column type="checkbox" align="center" fixed="left" width="40"/>
         <ux-table-column
                 v-for="item in columns"
                 :key="item.id"
                 :resizable="item.resizable"
                 :field="item.prop"
                 show-header-overflow='tooltip'
                 :title="item.label"
                 :width="item.width"
                 :fixed="item.fixed"
                 align="center"/>
     </ux-grid>
     <div class="paginationBox" style="height: 30px;">
        <el-pagination
            small
            background
            :current-page="page"
            :page-size="page_size"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :total="total" />
    </div>
    <el-dialog
        title="批量编辑"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <div>
            <span>备注：</span>
            <el-input
                placeholder="请输入备注"
                style="width:60%"
                v-model.trim="note_edit"
                size='small'
                clearable>
            </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
            <el-button type="primary" @click="editUpload" size="mini">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>
<script>
import columnsJson from '../json/total.js'
import searchTemplate from '../searchTemplate.vue'
    export default {
        components:{
            searchTemplate
        },
      data() {
        return {
          height: 0,
          columns: [],//表头
          scrollTop: 0,
            timeMonth:'',
          multipleSelection:[],
          multipleSelection1:{},
          dialogVisible:false,
          note_edit:'',
          search_data:[],
          page:1,
          page_size:100,
          total:0,
          selectionList:[],
          flag:false
        }
      },
      created(){
        var date = new Date();
        if (date.getMonth() === 0) { // 默认值为上个月份；月份为 0 时处理跨年问题
            this.timeMonth = (date.getFullYear() - 1) + '-' + '12'
        } else {
            this.timeMonth = date.getFullYear() + '-' + ((date.getMonth()) < 10 ? '0' + (date.getMonth()) : (date.getMonth()));
        }
        this.columns = columnsJson;
      },
      mounted () {
        // this.height = document.documentElement.clientHeight - 320 > 400 ? document.documentElement.clientHeight - 320 : 400
        this.$nextTick(() => {
          this.computeGridHeight()
          window.addEventListener('resize', this.computeGridHeight, { passive: true })
        })
        this.init({page:1})
      },
      methods: {
        computeGridHeight () {
            this.$nextTick(() => {
              try {
                const viewportH = window.innerHeight || document.documentElement.clientHeight
                const gridEl = this.$refs.plxTable && this.$refs.plxTable.$el
                const pagEl = this.$refs.pagination
                if (!gridEl) return
                const gridTop = gridEl.getBoundingClientRect().top
                const pagH = pagEl ? pagEl.offsetHeight : 56
                const gap = 16
                const footer = 2
                let h = Math.floor(viewportH - gridTop - pagH - gap - footer)
                if (h < 300) h = 300
                this.height = h
              } catch (e) {
                const h = document.documentElement.clientHeight - 320
                this.height = h > 400 ? h : 400
              }
            })
          },
          search_event(data){
              this.search_data = data;
                this.init({page:1})
          },
          editUpload(){
              if(this.note_edit == ''){
                  this.$message({
                        message: '请输入备注',
                        type: 'warning'
                    })
                  return;
              }
              var arr = [];
                this.multipleSelection.forEach((item)=>{
                    arr.push(item.id)
                })
              this.$loading(this.$loadingConfig)
                this.$axios.post(this.URL.BASEURL + this.URL.batchSetNotes,{
                    ids: arr,
                    note: this.note_edit
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.$message({
                            message: '编辑成功！',
                            type: 'success'
                        })
                        this.dialogVisible = false;
                        this.init({page:this.page})
                    }else {
                        this.$loading(this.$loadingConfig).close()
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                    this.$loading(this.$loadingConfig).close()
                })
          },
          batchEdit(){//批量编辑
            if(!this.multipleSelection || this.multipleSelection.length == 0){
                this.$message({
                    message: '未选择要编辑的订单',
                    type: 'warning'
                })
                return
            }
            this.dialogVisible = true;
          },
          uploadSuccess(res, file, fileList){
            this.$loading(this.$loadingConfig).close()
            if(res.errno == 0){
                var not_exists = `<p>${res.rst.info?res.rst.info:'导入成功！'}</p>`
                this.$alert(not_exists, res.err, {
                    dangerouslyUseHTMLString: true
                });
            }else {
                var errHint = ''
                if(Array.isArray(res.rst.error)){
                    errHint = '<p>有误字段：</p><ul>'
                    res.rst.error.forEach((item)=>{
                        errHint += `<li>第${item.row}行：${item.error.join(',')}</li>`
                    })
                    errHint += '</ul>'
                }else{
                    errHint = res.rst.error
                }
                this.$alert(errHint, res.err, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                });
            }
        },
        uploadError(err, file, fileList){
            this.$loading(this.$loadingConfig).close()
            this.$message({
                message: '上传失败',
                type: 'fail'
            })
        },
        uploadProgress(){//上传中
            this.$loading(this.$loadingConfig)
        },
        clearSelection(){//清空选中
            this.$refs.plxTable.clearSelection();
            this.multipleSelection1 = {};
            this.multipleSelection = [];
            this.selectionList = []
        },
        toggleSelection(rows) {
            if (rows) {
            rows.forEach((row,index) => {
                this.$refs.plxTable.toggleRowSelection([
                    {
                        row: row,
                        selected: true
                    }
                ])
                if(index == rows.length-1){
                    this.flag = true
                }
            });
          }
        },
        handleCurrentChange(val){
            this.init({page:val,selection:'clear'})
        },
        init({page,exportFlag,selection}){
            if(!selection || selection != 'clear'){
                this.clearSelection()
            }
            var params = {
                page:page,
                pagesize: this.page_size,
                is_negative:1,
                month:this.timeMonth,
            }
            if(exportFlag){
                params.page = 1;
                params.pagesize = 10000
            }else{
                page = page?page:1;
                params.page = page;
                this.page = page;
            }
            if(this.search_data.length==0){
                params.month = this.timeMonth
            }else{
                this.search_data.forEach((item)=>{
                    if(item.property == 'if_public' || item.property == 'is_refund'){
                        params[item.property] = item.values == '是' ? 1 : null
                    }else{
                        params[item.property] = item.values
                    }
                })
            }
            this.$loading(this.$loadingConfig);
            this.$axios.get(this.URL.BASEURL + this.URL.orderIndex,{
                params
            }).then((res) => {
                var res=res.data;
                this.$loading(this.$loadingConfig).close()
                if(res&& res.errno == 0){
                    var data = res.rst;
                    if(exportFlag){
                        this.$exportOrder({source:'negative',dataList:data.data,name:'负利润表'})
                    }else{
                        this.total = data.pageInfo.total;
                        this.datas = data.data // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
                        this.$refs.plxTable.reloadData(this.datas)
                        this.$nextTick(()=>{
                            if(this.multipleSelection1['page_'+this.page] && this.multipleSelection1['page_'+this.page].length != 0){
                                var rows = [],arr = []
                                this.multipleSelection1['page_'+this.page].forEach((item)=>{
                                    arr.push(item.id)
                                })
                                rows = this.datas.filter((v)=>{
                                    return arr.indexOf(v.id) != -1
                                })
                                this.flag =false
                                this.toggleSelection(rows)
                            }else{
                                this.flag = true
                            }
                        })
                    }
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.$loading(this.$loadingConfig).close()
            })
        },
       scroll ({scrollTop, scrollLeft}) {
         this.scrollTop = scrollTop
       },
        selectable ({row}) {//选择表格限制条件
            return row.id !== 2
        },
        selectionChange (row) {// 选中的行
          this.selectionList = row;
          if(this.flag){
            this.multipleSelection1['page_'+this.page] = this.selectionList;
            this.multipleSelection = [];
            for(var i in this.multipleSelection1){
                this.multipleSelection = this.multipleSelection.concat(this.multipleSelection1[i])
            }
          }
        },
      },
    }
  </script>
  <style lang="scss" scoped>
  @import '@/assets/css/tableStyle.scss';
  .topOperation{
      display: flex;
      align-items: top;
      .screenBox{
          flex: 1;
      }
  }
  .TableBox{
      padding:15px;
      background: #fff;
      margin-top: 15px;
  }
  .fileTemplate{
    font-size: 12px;
    margin-right: 10px;
    text-decoration: underline;
    margin: 8px 10px 0 0;
    color:#5B7BFE;
    display: block;
}
.batchDelete{
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #5B7BFE;
    background: #5B7BFE;
    color: #fff;
    margin-right: 16px;
    cursor: pointer;
    padding: 0 4px;
}
.uxGridBox{
    margin-top: 15px;
}
.refreshIcon{
    margin-right: 10px;
    background: #67c23a;
    border-color:#67c23a ;
  }
  </style>


// WEBPACK FOOTER //
// src/components/Order/medium/negativeList.vue